import type { OrganiserPageDTO, WomenTripCardDTO } from "@majourneys/shared";
import { apiBase, apiHeaders } from "../../../lib/api-base";

/**
 * Women-only group trips: the hub's cards and an organiser's page.
 *
 * Both routes are mounted off the main Elysia chain (see
 * apps/api/src/features/women-trips/routes/index.ts), so they are not on the
 * Eden client's type and are called with a plain fetch, like the ambassador
 * pages. Neither ever carries payment details.
 *
 * Prices are asked for in dirhams and converted on the page, like every other
 * card, so the server HTML and the guest's currency switch agree.
 */
export class WomenApiError extends Error {
  constructor(public status: number) {
    super(`women_api_${status}`);
    this.name = "WomenApiError";
  }
}

async function call<T>(path: string): Promise<T> {
  const res = await fetch(`${apiBase()}${path}`, { headers: apiHeaders() });
  if (!res.ok) throw new WomenApiError(res.status);
  return (await res.json()) as T;
}

const query = (lang: string) => `lang=${encodeURIComponent(lang)}&currency=MAD`;

export const womenApi = {
  trips: (lang: string) => call<WomenTripCardDTO[]>(`/women/trips?${query(lang)}`),
  organiser: (slug: string, lang: string) =>
    call<OrganiserPageDTO>(`/organisers/${encodeURIComponent(slug)}?${query(lang)}`),
};
